module.exports = __webpack_public_path__ + "static/media/KE.09c97b3a.png";